const convertTurkishCharacters = text => {
  return text
    .split('Ğ').join('g')
    .split('Ü').join('u')
    .split('Ş').join('s')
    .split('I').join('i')
    .split('İ').join('i')
    .split('Ö').join('o')
    .split('Ç').join('c')
    .split('ğ').join('g')
    .split('ü').join('u')
    .split('ş').join('s')
    .split('ı').join('i')
    .split('ö').join('o')
    .split('ç').join('c');
};

export const makeUrlPath = text => {
  return convertTurkishCharacters(text).toLowerCase().replace(/(\s|\/)/ig, '-');
};

export const isTextEqualToUrl = (text, url) => {
  return makeUrlPath(text) === url;
};

export const authorDetailRedirection = val => {
  const tempLabel = val?.name.split(' ').join('-');
  const temp = makeUrlPath(tempLabel);
  const redirectUrl = `https://www.bilyoner.com/yazarlar/yazar-detay/${ temp }-${ val?.id } `;
  return redirectUrl;
};

export default convertTurkishCharacters;
